// extracted by mini-css-extract-plugin
module.exports = {"body":"TaskDetailModal_body__EgB3e","descRow":"TaskDetailModal_descRow__tute4","desc":"TaskDetailModal_desc__1g76j"};